import roundValue from './roundValue'



const parseDXF = (data) => {
  console.log('parsing DXF');
  var retval = {
    lines: [],
    gx: 1,
    gy: 1
  };

  var boundary = [];
  var lineSegments = [];
  var ox; // origin x;
  var oy; // origin y;
  var hx; // highest lx;
  var hy; // highest ly;

  for(var i in data.tables.layers){    

    if(i === 'A_LINES_DRAFTING'){
      retval.type = "DRAFTING";
    } 
    if(i === 'A_LINES_MODEL'){
      retval.type = "MODEL";
    }
  }


  for(var i in data.entities){
    var e = data.entities[i];
    // console.log(e);

    if(e.layer === 'B_BOUNDARY' && (e.type === 'POLYLINE' || e.type === 'LWPOLYLINE' || e.type === 'LINE')){
      boundary.push(e);
      continue;
    }

    if((e.layer === 'A_LINES_DRAFTING' || e.layer === 'A_LINES_MODEL') && e.type === 'LINE'){
      var l = {
        x1: e.start.x,
        y1: e.start.y,
        x2: e.end.x,
        y2: e.end.y
      }

      // initialize limits
      if(ox === undefined) ox = l.x1;
      if(oy === undefined) oy = l.y1;
      if(hx === undefined) hx = l.x1;
      if(hy === undefined) hy = l.y1;

      // find lowest point
      if(l.x1 < ox) ox = l.x1;
      if(l.x2 < ox) ox = l.x2;
      if(l.y1 < oy) oy = l.y1;
      if(l.y2 < oy) oy = l.y2;

      // find highest point
      if(l.x1 > hx) hx = l.x1;
      if(l.x2 > hx) hx = l.x2;
      if(l.y1 > hy) hy = l.y1;
      if(l.y2 > hy) hy = l.y2;

      lineSegments.push(l);
    }

    if((e.layer === 'A_LINES_DRAFTING' || e.layer === 'A_LINES_MODEL') && (e.type === 'LWPOLYLINE' || e.type === 'POLYLINE')){

      for(var v = 0; v < e.vertices.length - 1; v++){
        var l = {
          x1: e.vertices[v].x,
          y1: e.vertices[v].y,
          x2: e.vertices[v+1].x,
          y2: e.vertices[v+1].y
        }

        // initialize limits
        if(ox === undefined) ox = l.x1;
        if(oy === undefined) oy = l.y1;
        if(hx === undefined) hx = l.x1;
        if(hy === undefined) hy = l.y1;

        // find lowest point
        if(l.x1 < ox) ox = l.x1;
        if(l.x2 < ox) ox = l.x2;
        if(l.y1 < oy) oy = l.y1;
        if(l.y2 < oy) oy = l.y2;

        // find highest point
        if(l.x1 > hx) hx = l.x1;
        if(l.x2 > hx) hx = l.x2;
        if(l.y1 > hy) hy = l.y1;
        if(l.y2 > hy) hy = l.y2;

        lineSegments.push(l);
      }
      
    }
  }

  var gx = hx - ox;
  var gy = hy - oy;
  
  // console.log('guessed GX,GY',gx,gy);

  if(boundary.length > 0){

    var lowest_x = Number.POSITIVE_INFINITY;
    var lowest_y = Number.POSITIVE_INFINITY;
    var highest_x = Number.NEGATIVE_INFINITY;
    var highest_y = Number.NEGATIVE_INFINITY;

    for(var i in boundary){

      var b = boundary[i];
      
      if(b.type === 'LINE'){
        if (b.start.x < lowest_x) lowest_x = b.start.x;
        if (b.start.y < lowest_y) lowest_y = b.start.y;
        if (b.end.x < lowest_x) lowest_x = b.end.x;
        if (b.end.y < lowest_y) lowest_y = b.end.y;

        if (b.start.x > highest_x) highest_x = b.start.x;
        if (b.start.y > highest_y) highest_y = b.start.y;
        if (b.end.x > highest_x) highest_x = b.end.x;
        if (b.end.y > highest_y) highest_y = b.end.y;
      } else {
        for (var i = 0; i < b.vertices.length; i++) {
          var v = b.vertices[i];
          if (v.x < lowest_x) lowest_x = v.x;
          if (v.y < lowest_y) lowest_y = v.y;
          if (v.x > highest_x) highest_x = v.x;
          if (v.y > highest_y) highest_y = v.y;
        }
      }

    }

    ox = lowest_x;
    oy = lowest_y;

    gx = highest_x - lowest_x;
    gy = highest_y - lowest_y;

    // console.log('parsed GX,GY',gx,gy);
  } 

  for(var i in lineSegments){
    var l = lineSegments[i];

    l.x1 -= ox;
    l.x2 -= ox;

    l.y1 -= oy;
    l.y2 -= oy;

    if(l.x1 > l.x2){
      var tx = l.x1;
      var ty = l.y1;
      l.x1 = l.x2;
      l.y1 = l.y2;

      l.x2 = tx;
      l.y2 = ty;
    }
  }

  retval.lines = lineSegments;
  retval.gx = gx;
  retval.gy = gy;


  return retval;
}

export default parseDXF;


// WEBPACK FOOTER //
// ./src/pattern_utilities/parseDXF.js